import { defineMessages } from 'react-intl'

const scope = `procurify.spending-cards.presenter.CardPinMenuButtonPresenter`

export default defineMessages({
  showPinMenuListItemText: {
    id: `${scope}.showPinMenuListItemText`,
    defaultMessage: 'Show PIN',
  },
  fetchingPinErrorToast: {
    id: `${scope}.fetchingPinErrorToast`,
    defaultMessage: 'Error fetching card PIN',
  },
})
